import { AccountBalance } from 'data/Account/types'
import { ApiCurrency, CurrencyProduct } from 'data/Currencies/types'
import { CurrencyDefinitionType } from 'data/types'

type CurrenciesData = {
  assetCurrencies: ApiCurrency[]
  balances: AccountBalance
  instrumentCurrencies: CurrencyDefinitionType[]
  paymentCurrencies: string[]
}
export default function getCryptoWithdrawOptions({
  assetCurrencies,
  balances,
  instrumentCurrencies,
  paymentCurrencies
}: CurrenciesData) {
  if (!balances) return []

  const allowedCryptoTargets = assetCurrencies
    .filter(({ type }) => type.name !== 'FIAT')
    .filter((c) => c.products.includes(CurrencyProduct.MercuryWithdrawals))
    .filter((c) => paymentCurrencies.includes(c.symbol))
    .filter((c) => instrumentCurrencies.some((ic) => ic.key === c.symbol && !ic.blocked))
  const cryptoTargetsFromFiatBalances = instrumentCurrencies
    .filter((i) => Number(balances[i.key]?.withdrawable) > 0)
    .map((i) => i.withdrawnAs)
    .flat()
  return allowedCryptoTargets.filter(
    (c) =>
      cryptoTargetsFromFiatBalances.includes(c.symbol) ||
      Number(balances[c.symbol]?.withdrawable) > 0
  )
}
